export default __webpack_public_path__ + "fb038f158d8c1b9dca40279a5f2a9270.svg";